import { FaInstagram, FaYoutube, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-df-surface border-t border-df-border pt-14 pb-8 px-4">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-flex items-center" style={{ gap: '0px' }}>
              <img src="/logo-dark.webp" alt="Tablero Infinito" className="h-28 w-28 md:h-32 md:w-32 object-contain -mr-10" />
              <span className="font-cinzel text-xl font-bold text-df-text">
                Tablero Infinito
              </span>
            </Link>
            <p className="text-df-muted text-sm leading-relaxed">
              Tu destino para juegos de mesa, cartas, rol y accesorios.
              Descubre, juega y conecta.
            </p>
            {/* Social */}
            <div className="flex gap-3 pt-2">
              <a
                href="https://www.instagram.com/tablero_infinito/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-df-surface2 border border-df-border flex items-center justify-center text-df-muted hover:text-pink-400 hover:border-pink-400 transition-all"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-df-surface2 border border-df-border flex items-center justify-center text-df-muted hover:text-red-400 hover:border-red-400 transition-all"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>
              <a
                href="https://wa.me/573021124424"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-df-surface2 border border-df-border flex items-center justify-center text-df-muted hover:text-green-400 hover:border-green-400 transition-all"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-df-text uppercase tracking-wider mb-4">
              Tienda
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-df-muted hover:text-df-accent text-sm transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/productos" className="text-df-muted hover:text-df-accent text-sm transition-colors">
                  Todos los Juegos
                </Link>
              </li>
              <li>
                <Link to="/productos?tipo=Tablero" className="text-df-muted hover:text-df-accent text-sm transition-colors">
                  Juegos de Tablero
                </Link>
              </li>
              <li>
                <Link to="/productos?tipo=Cartas" className="text-df-muted hover:text-df-accent text-sm transition-colors">
                  Juegos de Cartas
                </Link>
              </li>
              <li>
                <Link to="/productos?tipo=Rol" className="text-df-muted hover:text-df-accent text-sm transition-colors">
                  Juegos de Rol
                </Link>
              </li>
              <li>
                <Link to="/ahilesdejo" className="text-df-gold hover:text-yellow-300 text-sm transition-colors font-medium">
                  🃏 Ahí les dejo
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-df-text uppercase tracking-wider mb-4">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2.5">
                <FaEnvelope className="text-df-accent text-sm flex-shrink-0" />
                <a
                  href="mailto:tableroinfinito@gmail.com"
                  className="text-df-muted hover:text-df-accent text-sm transition-colors"
                >
                  tableroinfinito@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <FaWhatsapp className="text-df-accent text-sm flex-shrink-0" />
                <a
                  href="https://wa.me/573021124424"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-df-muted hover:text-df-accent text-sm transition-colors"
                >
                  +57 302 112 4424
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-sm font-semibold text-df-text uppercase tracking-wider mb-4">
              Horario
            </h4>
            <ul className="space-y-2">
              <li className="flex justify-between text-sm">
                <span className="text-df-muted">Lun - Vie</span>
                <span className="text-df-text">10:00 AM - 8:00 PM</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-df-muted">Sábados</span>
                <span className="text-df-text">9:00 AM - 6:00 PM</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-df-muted">Dom y festivos</span>
                <span className="text-df-muted/60">Cerrado</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-df-border pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-df-muted/60 text-xs">
              © {currentYear} Tablero Infinito. Todos los derechos reservados.
            </p>
            <div className="flex gap-6">
              <Link to="/terminos-condiciones" className="text-df-muted/60 hover:text-df-muted text-xs transition-colors">
                Términos y condiciones
              </Link>
              <Link to="/politica-privacidad" className="text-df-muted/60 hover:text-df-muted text-xs transition-colors">
                Política de privacidad
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
